import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FiArrowRight } from "react-icons/fi";
import FadeIn from "../ui/FadeIn";
import SectionHeader from "../ui/SectionHeader";
import { APIURL } from "../../Constants";
import {
  services as profileServices,
  servicesIntro,
  technicalSkills,
} from "../../content/companyProfile";
import "./ServicesPage.css";

const ServicesPage = () => {
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${APIURL}/services/get`)
      .then((response) => setServiceData(response.data))
      .catch(() => setServiceData(null))
      .finally(() => setLoading(false));
  }, []);

  const hasApiData = Array.isArray(serviceData) && serviceData.length > 0;

  return (
    <div className="vp-page vp-services-page">
      <div className="vp-page-hero">
        <div className="vp-container">
          <span className="vp-eyebrow">Services</span>
          <h1>Software solutions that scale with you</h1>
          <p>{servicesIntro}</p>
          <Link to="/enquiry" className="vp-btn vp-btn--primary" style={{ marginTop: "1.5rem" }}>
            Get Started
          </Link>
        </div>
      </div>

      <section className="vp-section">
        <div className="vp-container">
          {loading ? (
            <p className="vp-services-page__status">Loading services…</p>
          ) : hasApiData ? (
            <div className="vp-services-page__grid">
              {serviceData.map((item, i) => (
                <FadeIn key={item.identifier || item._id} delay={i * 0.05}>
                  <article className="vp-card vp-service-page-card">
                    {item.image && (
                      <img src={item.image} alt="" className="vp-service-page-card__img" />
                    )}
                    <h3>{item.title}</h3>
                    <p>{item.subTitle}</p>
                    <Link
                      to={`/service/${item.identifier}`}
                      className="vp-service-page-card__link"
                    >
                      Learn more
                      <FiArrowRight aria-hidden />
                    </Link>
                  </article>
                </FadeIn>
              ))}
            </div>
          ) : (
            <div className="vp-services-page__grid">
              {profileServices.map(({ icon: Icon, title, description }, i) => (
                <FadeIn key={title} delay={i * 0.05}>
                  <article className="vp-card vp-service-page-card">
                    <div className="vp-service-card__icon">
                      <Icon aria-hidden />
                    </div>
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <Link to="/enquiry" className="vp-service-page-card__link">
                      Get a quote
                      <FiArrowRight aria-hidden />
                    </Link>
                  </article>
                </FadeIn>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="vp-section vp-section--surface">
        <div className="vp-container">
          <SectionHeader
            eyebrow="Stack"
            title={technicalSkills.title}
            description={technicalSkills.intro}
            align="center"
          />
          <div className="vp-services-skills">
            {technicalSkills.items.map((item, i) => (
              <FadeIn key={item.title} delay={i * 0.05}>
                <article className="vp-skill-block">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <div className="vp-skill-block__tags">
                    {item.tags.map((tag) => (
                      <span key={tag} className="vp-tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                </article>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="vp-cta-block">
        <div className="vp-container vp-cta-block__inner">
          <div>
            <h2>Have a project in mind?</h2>
            <p>Tell us what you need—we will respond with a plan and quotation.</p>
          </div>
          <Link to="/enquiry" className="vp-btn vp-btn--primary">
            Start a project
            <FiArrowRight aria-hidden />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
